import { Banner, Text } from '@cloudflare/kumo'
import { WarningCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from '../i18n'

export function NotEnrolledPage() {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-kumo-base text-kumo-default p-6">
      <div className="max-w-140 w-full space-y-4">
        <div className="flex items-center gap-3 mb-3">
          <WarningCircleIcon size={32} className="text-kumo-subtle" />
          <Text variant="heading2" as="h1">
            {t('notEnrolled.title')}
          </Text>
        </div>
        <Banner variant="alert">{t('notEnrolled.message')}</Banner>
        <Text variant="secondary">{t('notEnrolled.contact')}</Text>
      </div>
    </div>
  )
}
